import { getItem } from '@/app/utils/toolkit/defaultItems';

const impactedByCovid = [
  {
    isImpacted: 'yes',
    description: 'As the tenant has been adversely financially impacted by Covid-19, the ATO will not take compliance action for the 2019/20 and 2020/21 years in relation to any rent relief provided as long as it is necessary, temporary and appropriately documented.',
  },
  {
    isImpacted: 'no',
    description: 'As the tenant has not been adversely financially impacted by Covid-19, if the fund trustee were to provide rent relief to the tenant, the fund risks breaching the superannuation law.  We do not recommend proceeding without receiving advice.',
  },
  {
    isImpacted: 'unknown',
    description: 'If the tenant has been adversely financially impacted by Covid-19, the ATO will not take compliance action for the 2019/20 and 2020/21 years in relation to any rent relief provided as long as it is necessary, temporary and appropriately documented.  However if the tenant has not been adversely financially impacted by Covid-19 but the fund trustee provided rent relief regardless, the fund risks breaching the superannuation law.  We do not recommend proceeding without receiving advice.',
  },
];

const rentReliefOutcomes = [
  {
    isImpactedByCovid: 'yes',
    isJobkeeper: 'yes',
    hasTurnover: 'yes',
    description: 'As the tenant is eligible for the Government’s JobKeeper program, and their turnover is less than $50m, the National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles will apply to this lease arrangement.  Individual tenants and landlords will determine their own lease adjustments taking into account the specific impact of the Covid-19 pandemic on their businesses.  However, the Code nonetheless sets out some important principles for good faith negotiations about rent adjustments at this time which must be used as a starting point.',
  },
  {
    isImpactedByCovid: 'yes',
    isJobkeeper: 'yes',
    hasTurnover: 'no',
    description: 'While the tenant is eligible for the Government’s JobKeeper program the National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles does not specifically apply to this arrangement as it is only mandatory where the tenant\'s turnover is less than $50m pa. However, the principles laid out nonetheless provide a guide to reasonable lease adjustments at this time.',
  },
  {
    isImpactedByCovid: 'yes',
    isJobkeeper: 'no',
    hasTurnover: 'yes',
    description: 'The National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles does not specifically apply to this arrangement as it is only mandatory where the tenant is eligible for the JobKeeper program.  However, the principles laid out nonetheless provide a guide to reasonable lease adjustments at this time provided the tenant has been adversely financially impacted by Covid-19.',
  },
  {
    isImpactedByCovid: 'yes',
    isJobkeeper: 'no',
    hasTurnover: 'no',
    description: 'The National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles does not specifically apply to this arrangement as it is only mandatory where the tenant is eligible for the JobKeeper program and has a turnover of less than $50m pa.  However, the principles laid out nonetheless provide a guide to reasonable lease adjustments at this time provided the tenant has been adversely financially impacted by Covid-19.',
  },
  {
    isImpactedByCovid: 'any',
    isJobkeeper: 'unknown',
    hasTurnover: 'unknown',
    description: 'It is not known whether the National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles specifically applies to this arrangement.  However, the principles laid out nonetheless provide a guide to reasonable lease adjustments at this time provided the tenant has been adversely financially impacted by Covid-19.',
  },
];

export const code = [
  {
    description: 'The principles on which the Code is based can be summarised as follows:',
  },
  {
    description: [
      'tenants and landlords should work together to share the economic impact of the Covid-19 pandemic in an appropriate way',
      'this should be done by putting in place temporary measures (such as rent deferrals, rent waivers etc) to help the tenant return to normal trading as soon as possible after the end of the pandemic, and',
      'the negotiations should be open, honest, in good faith and appropriately balance the needs and interests of both the tenant and landlord.',
    ],
  },
  {
    description: 'The Code also has some specific requirements which are explained throughout this tool.',
  },
];

export const nextSteps = [
  {
    outcome: true,
    steps: [
      'Complete Rent Relief Drivers',
      'Complete Rent Relief Adjustments',
      'Review Rent Relief Information',
      'Download Rent Relief Document Pack',
    ],
  },
  {
    outcome: false,
    steps: [
      'Review Rent Relief Information',
      'Download Rent Relief Determination',
      'Seek advice as required',
    ],
  },
];

export function rentReliefDetermination({ isJobkeeper, hasTurnover, isImpactedByCovid }) {
  const validOutcome = rentReliefOutcomes.find(outcome => (outcome.isJobkeeper === isJobkeeper && outcome.hasTurnover === hasTurnover && (outcome.isImpactedByCovid === isImpactedByCovid || outcome.isImpactedByCovid === 'any')));
  return (validOutcome ? validOutcome.description : '');
}

export function isImpactedByCovidDetermination(isImpactedByCovid) {
  const validOutcome = impactedByCovid.find(impact => impact.isImpacted === isImpactedByCovid);
  return (validOutcome ? validOutcome.description : '');
}

export function setImpactedByCovid(impactedByCovidValue) {
  if (impactedByCovidValue === 'no') {
    return ({
      determination: {
        impactedByCovid: impactedByCovidValue,
      },
      adjustments: getItem('RENT_RELIEF').default.adjustments,
    });
  }
  return ({ determination: { impactedByCovid: impactedByCovidValue } });
}

export default {
  code,
  nextSteps,
  rentReliefDetermination,
  isImpactedByCovidDetermination,
};
